import React, { useState, useEffect } from 'react';
import LoaderWheel from './LoaderWheel';

export default function Loader(props) {
  let classNames = props.className ? props.className.split(' ') : [];

  if (props.textAlign && props.textAlign === 'right') {
    classNames.push('text-right');
  } else {
    classNames.push('text-center');
  }

  if (props.size && props.size === 'large') {
    return (
      <h2 className={classNames.join(' ')}>
        <LoaderWheel />
      </h2>
    );
  } else {
    return (
      <p className={classNames.join(' ')}>
        <LoaderWheel />
      </p>
    );
  }
}
